<mat-form-field #formFieldContainer  floatLabel="always" class="switch-box-class" [hideRequiredMarker]="hideRequired">
  <mat-label
    #labelContainer  (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} control-label"
             [title]="componentDefinition?.label">
    {{componentDefinition?.label}}
  </mat-label>

  <div class="labelToolTipContainer"
    #tooltip="matTooltip"
    matTooltip="{{componentDefinition.label}}"
    [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>

  <input matInput placeholder="{{ componentDefinition?.label }}"
         hidden [required]="isRequired"
         [formControl]="formControl">
  <mat-slide-toggle
    [id]="elementName + document.documentId"
    [name]="componentDefinition?.name"
    [title]="fieldValue?'':componentDefinition?.label"
    [formControl]="formControl">
  </mat-slide-toggle>
</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
